import { TransferTranslations } from "./transferTranslations.types";

const transferUkTranslations: TransferTranslations = {
    "transferPage": {
        "title": "Transfer",
        "noTransferTitle": "I don't require a transfer",
        "noTransferDescription": "Continue without adding a station transfer",
        "tneStationPopupTitle": "Need a transfer from the train station?",
        "tneStationPopupDescription": "We offer shared bus and private taxi transfers to selected Alpine resorts.",
        "tneStationPopupNoTransfer": "Skip transfer",
        "tneStationPopupWantTransfer": "Add a transfer",
        "tneStationFilterLabel": "Your ski resort",
        "tneStationCardTitle": "Book your transfer to your ski resort.",
        "tneStationCardDescription": "A simple and convenient way to reach your destination without worrying about connections.",
    },
    transferFilters: {
        title: 'Transfer preferences',
        options: {
            shortWaitingTime: 'Short waiting time',
            doorToDoor: 'Door-to-door',
            privateGroup: 'Private - just for your group',
            carRental: 'Car rental',
        },
    },
    "bus": {
        title: 'Bus',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'May require bus changes en route or walking to your stay.',
        description: 'A shared shuttle with fixed times and multiple stops. Bus changes or walking may be needed.'
    },
    "busLesArcs": {
        title: 'Bus + Funiculaire',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'Walk to your accommodation.',
        description: 'The journey takes place in two stages: bus to Bourg-Saint-Maurice, then funicular to Les Arcs.'
    },
    "taxi": {
        title: 'Taxi',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'Door-to-door service',
        description: 'Private transfer with a dedicated driver for your exclusive use.'
    },
    "funicular": {
        title: 'Funicular',
        estimatedTransferTime: 'Estimated transfer time:',
        note: 'Door-to-door service',
        description: 'Reach Les Arcs easily thanks to the ultramodern funicular, which connects Bourg-Saint-Maurice station to Les Arcs 1600 station in just 7 minutes.'
    },
    alps2alps: {
        vehicle2: {
            title: 'Standard Taxi',
            description: 'A transfer suited for travelers alone or small families traveling without ski equipment.',
        },
        vehicle10: {
            title: 'Minivan – 7 seats',
            description: 'A spacious vehicle, perfect for families and small groups traveling with luggage and ski equipment.',
        },
        vehicle15: {
            title: 'Minivan – 16 seats',
            description: 'The ideal solution for traveling together while simplifying the organization of large groups.',
        },
        vehicle19: {
            title: 'Shared Taxi',
            description: 'An economical and environmentally friendly option to reach your station by sharing your trip with other travelers.',
        },
        upToPassengers: 'Up to {count} passengers',
        estimatedTransferTime: 'Estimated travel time:',
        doorToDoor: 'Door-to-door service',
    },
}

export default transferUkTranslations;